import LeadSectionContainer from "common/components/leads/LeadSectionContainer";
import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { typedObjectEntries } from "common/helpers/utils";
import type { DetailedLead } from "common/types";

export default function LeadSource({
  origins,
}: {
  origins: DetailedLead["origins"];
}) {
  if (!origins.length) {
    return;
  }
  const tagComponent = (
    <Tag variant="tertiary" className="shrink">
      <span className="truncate">
        {origins.length > 1 ? "Multiple sources" : origins[0].name}
      </span>
    </Tag>
  );

  const groupedOrigins = origins.reduce<Record<string, number>>(
    (accumulator, { name }) => {
      if (accumulator[name]) {
        accumulator[name] += 1;
      } else {
        accumulator[name] = 1;
      }
      return accumulator;
    },
    {},
  );

  return (
    <LeadSectionContainer title="Origin" isColumn={false} hasBorder>
      {origins.length > 1 ? (
        <Tooltip>
          <TooltipTrigger asChild>{tagComponent}</TooltipTrigger>
          <TooltipContent className="w-fit max-w-64">
            {typedObjectEntries(groupedOrigins)
              .map(([name, count]) => (count > 1 ? `${name} x${count}` : name))
              .join(", ")}
          </TooltipContent>
        </Tooltip>
      ) : (
        tagComponent
      )}
    </LeadSectionContainer>
  );
}
